import axios from '../../axios.js'

if (!axios.defaults.headers.common["Authorization"]) {
  const token = localStorage.getItem('accessToken');
  if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  }
}

export default axios
